import { Button, Card, CardContent, Grid, Paper } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { experimentsService } from '../../Services/Experiments.services';
import { Header } from '../../Components/Shared/Header/Header';
import SkeletonComponent from '../../Components/SkeletonComponent';
import { useEffect, useState } from 'react';
import StatusTable from '../../Components/BodyComponent/Experiments/StatusTable';
import ExperimentTitle from '../../Components/BodyComponent/Experiments/ExperimentTitle';
import ExperimentBreadcrumbs from '../../Components/BodyComponent/Experiments/ExperimentBreadcrumbs';
import { useSelector } from 'react-redux';

function ExperimentStatusPage() {
    const { experimentId } = useParams();
    const { isAdmin } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [isStatusLoading, setIsStatusLoading] = useState(true);
    const [status, setStatus] = useState([]);

    const fetchStatus = async () => {
        setIsStatusLoading(true);

        try {
            const status = await experimentsService.getExperimentStatus(experimentId);
            setStatus(status);
        } catch (err) {
            console.error('Error fetching the status:', err);
            setStatus([]);
        } finally {
            setIsStatusLoading(false);
        }
    };

    useEffect(() => {
        fetchStatus();
    }, [experimentId]);

    const handleGoToEvaluation = () => {
        navigate(`/experiments/${experimentId}/evaluation`);
    };

    const handleAddRun = async () => {
        try {
            const newRun = await experimentsService.createExperimentRun(experimentId);

            if (newRun?.id) {
                navigate(`/experiments/${experimentId}/runs/${newRun.id}`);
            }
        } catch (error) {
            console.error('Error creating experiment:', error);
        }
    };

    const handleRunDelete = async (documentId) => {
        try {
            await experimentsService.deleteExperimentRun(experimentId, documentId);
            setStatus((status) => status.filter((doc) => doc.id !== documentId));
        } catch (err) {
            console.error('Error deleting the run:', err);
        } finally {
            setIsStatusLoading(false);
        }
    };

    const handleViewDocs = () => {
        navigate(`/experiments/${experimentId}/docs`);
    };

    const handleViewResults = () => {
        navigate(`/experiments/${experimentId}/results`);
    };

    const handleViewRuns = () => {
        navigate(`/experiments/${experimentId}/runs`);
    };

    return (
        <Grid item xs={12} sm={12} md={12} sx={{ mt: 2, mb: 2 }}>
            <Card component={Paper}>
                <CardContent>
                    <div className="header">
                        <Header
                            title={(
                                <ExperimentBreadcrumbs
                                    crumbs={[
                                        {
                                            label: 'Experiments',
                                            href: '/experiments',
                                        },
                                        {
                                            label: (<ExperimentTitle experimentId={experimentId} />),
                                        },
                                    ]}
                                    pageTitle="Progress"
                                />
                            )}
                            actionButtons={[
                                isAdmin && (
                                    <Button
                                        key="add-run-button"
                                        variant="outlined"
                                        sx={{ ml: 2 }}
                                        onClick={handleAddRun}
                                    >
                                        Add Run
                                    </Button>
                                ),
                                isAdmin && (
                                    <Button
                                        key="go-to-runs-button"
                                        variant="outlined"
                                        onClick={handleViewRuns}
                                    >
                                        Runs
                                    </Button>
                                ),
                                isAdmin && (
                                    <Button
                                        key="go-to-docs-button"
                                        variant="outlined"
                                        onClick={handleViewDocs}
                                    >
                                        Docs
                                    </Button>
                                ),
                                isAdmin && (
                                    <Button
                                        key="go-to-results-button"
                                        variant="outlined"
                                        onClick={handleViewResults}
                                    >
                                        Results
                                    </Button>
                                ),
                                (
                                    <Button
                                        key="go-to-evaluation-button"
                                        variant="contained"
                                        sx={{ ml: 2 }}
                                        onClick={handleGoToEvaluation}
                                    >
                                        Evaluate
                                    </Button>
                                ),
                            ]}
                        />
                    </div>
                    <div>
                        {isStatusLoading
                            ? (
                                <SkeletonComponent />
                            ) : (
                                <StatusTable
                                    results={status}
                                    onRunDelete={handleRunDelete}
                                />
                            )}
                    </div>
                </CardContent>
            </Card>
        </Grid>
    );
}

export default ExperimentStatusPage;
